import React, { lazy, Suspense } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import * as Translations from '../../../../providers/i18n';
import * as TeamSelectors from '../../../../selectors/team';

const MembersTagsInput = lazy(() => import(/* webpackChunkName: 'MembersTagsInput' */'@fiverr-private/user_multiselect_input'));

const handleChange = (onChange) => (items) => {
    const emails = items.map((items) => items.email);
    onChange(emails);
};

function TeamMemberInput({ i18n, members, onChange }) {
    const props = {
        users: members,
        allowInvites: true,
        perseusClassName: 'order_page_perseus',
        onChange: handleChange(onChange),
        placeholderText: i18n.t('attachments_preview.invite.enter_new_emails_or_names'),
        addAllEnabled: false
    };

    return (
        <Suspense fallback={null}>
            <MembersTagsInput {...props}/>
        </Suspense>
    );
}

TeamMemberInput.propTypes = {
    members: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.number,
            full_name: PropTypes.string,
            username: PropTypes.string,
            email: PropTypes.string,
            imageUrl: PropTypes.string
        })
    ).isRequired,
    onChange: PropTypes.func,
    i18n: PropTypes.shape({
        t: PropTypes.func
    })
};

const mapStateToProps = (state) => ({
    members: TeamSelectors.getTeamMembersAsInputItems(state)
});

export default compose(
    Translations.connect,
    connect(mapStateToProps)
)(TeamMemberInput);
